// extracted by mini-css-extract-plugin
export default {"overlay":"eXLjGR","overlay--hidden":"f5mp22","transparent":"sw_gCG"};